import React, { useEffect, useState } from "react";
import axios from "axios";
import { Bell, Settings2 } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const auth = () => {
  const t = localStorage.getItem("apex_token");
  return t ? { Authorization: `Bearer ${t}` } : {};
};

export const LimitsBar = ({ owner, settings, onChange }) => {
  const [cap, setCap] = useState(settings.cap_pct);
  const [ai, setAi] = useState(settings.ai_limit_pct);
  const [msg, setMsg] = useState("");
  const [push, setPush] = useState(null);

  useEffect(() => { setCap(settings.cap_pct); setAi(settings.ai_limit_pct); }, [settings]);
  useEffect(() => {
    axios.get(`${API}/portfolio-engine/push-status`, { headers: auth() }).then((r) => setPush(r.data.enabled)).catch(() => setPush(false));
  }, []);

  const save = async () => {
    try {
      const r = await axios.put(`${API}/portfolio-engine/settings/${owner}`, { cap_pct: +cap, ai_limit_pct: +ai }, { headers: auth() });
      onChange(r.data);
      setMsg("Enregistré");
    } catch (e) {
      setMsg(e?.response?.data?.detail || "Erreur");
    }
    setTimeout(() => setMsg(""), 2500);
  };
  const testPush = async () => {
    const r = await axios.post(`${API}/portfolio-engine/push-test`, {}, { headers: auth() }).catch(() => null);
    setMsg(r?.data?.sent ? "Notification envoyée sur l'iPhone" : "Échec de l'envoi");
    setTimeout(() => setMsg(""), 3000);
  };

  const Field = ({ label, value, set, testid }) => (
    <label className="flex items-center gap-2 text-xs text-slate-400">
      {label}
      <input type="number" value={value} onChange={(e) => set(e.target.value)}
        className="w-16 bg-slate-900 border border-slate-700 focus:border-cyan-500 outline-none rounded px-2 py-1 text-slate-100 font-mono" data-testid={testid} />
      %
    </label>
  );

  return (
    <div className="flex flex-wrap items-center gap-3 bg-slate-800/40 border border-slate-700 rounded-lg px-3 py-2" data-testid="pe-limits">
      <Settings2 className="w-4 h-4 text-cyan-400" />
      {Field({ label: "Plafond par action", value: cap, set: setCap, testid: "pe-limit-cap-input" })}
      {Field({ label: "Limite IA / semis", value: ai, set: setAi, testid: "pe-limit-ai-input" })}
      <button onClick={save} className="text-xs font-semibold rounded-full px-3 py-1 bg-cyan-600 hover:bg-cyan-500 text-white transition-colors" data-testid="pe-limits-save-btn">
        Enregistrer
      </button>
      <span className="flex items-center gap-1.5 text-xs ml-auto" data-testid="pe-push-status">
        <Bell className={`w-4 h-4 ${push ? "text-emerald-400" : "text-slate-500"}`} />
        {push ? "Alertes iPhone actives" : "Alertes iPhone : clés Pushover manquantes"}
        {push && (
          <button onClick={testPush} className="underline text-cyan-300 hover:text-cyan-200" data-testid="pe-push-test-btn">tester</button>
        )}
      </span>
      {msg && <span className="text-xs text-emerald-300 w-full" data-testid="pe-limits-msg">{msg}</span>}
    </div>
  );
};
